import { isPlatformBrowser } from '@angular/common';
import { Component, Inject, PLATFORM_ID } from '@angular/core';

@Component({
  selector: 'app-indicator',
  templateUrl: './indicator.component.html',
  styleUrls: ['./indicator.component.scss']
})
export class IndicatorComponent {
  colorList: {
    colorCode: string;
    name: string;
    borderColor: string;
    status: string;
    label: string;
  }[] = [{
    colorCode: '#C038A4',
    name: 'Magenta',
    borderColor: '#E6AFDB',
    status: 'Not Yet started',
    label: 'Not Yet started'
  },
  {
    colorCode: '#915AB7',
    name: 'Purple',
    borderColor: '#D3BDE2',
    status: 'Not Completed',
    label: 'Not Completed'
  },
  {
    colorCode: '#994D2B',
    name: 'Orange',
    borderColor: '#FFCCB6',
    status: 'Awaiting Grading',
    label: 'Awaiting Grading'
  },
  {
    colorCode: '#0D842F',
    name: 'Green',
    borderColor: '#9ECEAC',
    status: 'Complete',
    label: 'Complete'
  }];

  colorObject: {
    colorCode: string;
    name: string;
    borderColor: string;
    status: string;
    label: string;
  } = this.colorList[0];

  valuePresence = true as boolean;
  hasValue = true;
  hasUrl = true;
  stringValue = false;
  numberValue = true;
  value = 5 as string | number;
  valueTypeList: string[] = ['string', 'number'];
  valueType = 'number';
  statusUrl = '/indicator';
  queryParams = { test: 'dummy' };

  isBrowser = true;

  constructor(
    @Inject(PLATFORM_ID) private platformId: Object
  ) {
    this.isBrowser = isPlatformBrowser(this.platformId);
  }

  onChange(event: any) {
    this.colorObject = this.colorList.find(obj => obj.colorCode === event.target.value) || this.colorList[0];
  }
}